// Módulos
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

// TEMPORAL
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Módulos propios
import { PagesModule } from './pages/pages.module';
import { ServiceModule } from './services/service.module';
import { ChartsModule } from 'ng2-charts';
// Rutas
import { APP_ROUTES } from './app.routes';

// Componentes
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { GraficoLineComponent } from './components/grafico-line/grafico-line.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    PagesModule,
    ServiceModule,
    APP_ROUTES,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule
  ],
  providers: [GraficoLineComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
